import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleTier } from '../../../core/models';

const TIER_META: Record<string, { label: string; color: string; bg: string; icon: string }> = {
  [ModuleTier.Basic]: { label: 'Basic', color: '#8b949e', bg: 'rgba(139,148,158,.12)', icon: '' },
  [ModuleTier.Gold]: { label: 'Gold', color: '#d29922', bg: 'rgba(210,153,34,.12)', icon: '' },
  [ModuleTier.Premium]: { label: 'Premium', color: '#bc8cff', bg: 'rgba(188,140,255,.12)', icon: '' },
};

@Component({
  selector: 'app-tier-badge',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (meta) {
      <span class="tier" [style.background]="meta.bg" [style.color]="meta.color" [class.small]="small">
        {{ meta.icon }} {{ meta.label }}
      </span>
    }
  `,
  styles: [`
    .tier {
      display: inline-flex; align-items: center; gap: 4px;
      padding: 3px 10px; border-radius: 12px;
      font-size: 11px; font-weight: 600; letter-spacing: .02em;
    }
    .tier.small { font-size: 10px; padding: 2px 7px; }
  `],
})
export class TierBadgeComponent {
  @Input() tier: ModuleTier | null = null;
  @Input() small = false;

  get meta() {
    if (this.tier == null) return null;
    return TIER_META[this.tier] ?? TIER_META[ModuleTier.Basic];
  }
}
